import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import { useEffect, useState } from 'react';
import {
  createNewSurveyAnswer,
  deleteSurveyAnswer,
} from 'redux/slices/legacySurveySlice.slice';
import { useAppDispatch } from 'redux/storeHooks';
import type { SurveyProps } from './types';

const SurveyCheckbox = ({
  question,
  register,
  response,
  getValues,
  unregister,
}: SurveyProps) => {
  const [selectValue, setSelectValue] = useState([]);
  const dispatch = useAppDispatch();

  const handleChange = event => {
    let newValue;
    if (event.target.checked) {
      newValue = [...selectValue, event.target.value];
      dispatch(
        createNewSurveyAnswer({
          body: {
            questionId: question.id,
            responseId: response.id,
            optionId: event.target.value,
          },
        })
      );
    } else {
      newValue = selectValue.filter(value => value !== event.target.value);
      dispatch(
        deleteSurveyAnswer({
          params: {
            questionId: question.id,
            responseId: response.id,
            optionId: event.target.value,
          },
        })
      );
    }
    setSelectValue(newValue);
  };

  const registerProps = register(question.id, {
    required: question.isRequired,
    onChange: handleChange,
  });

  useEffect(() => {
    const initialValue = getValues(question.id);

    if (initialValue) {
      setSelectValue(initialValue);
    }

    return () => {
      unregister(question.id);
    };
  }, []);

  return (
    <FormControl fullWidth>
      <FormLabel required={question.isRequired} sx={{ fontSize: '.75rem' }}>
        {question.inputTitle}
      </FormLabel>
      <FormGroup>
        {question.options.map(option => {
          return (
            <FormControlLabel
              key={option.id}
              label={option.text}
              control={
                <Checkbox
                  {...registerProps}
                  name={question.id}
                  checked={selectValue.includes(option.id)}
                  value={option.id}
                />
              }
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};

export default SurveyCheckbox;
